/**
 * @param {string} status
 * @returns {"default"|"processing"|"success"|"error"|"warning"}
 */
export function aiSalesStatusColor(status) {
  const s = String(status || "").toLowerCase();
  if (s === "hot") return "error";
  if (s === "offers_ready") return "success";
  if (s === "closed") return "default";
  if (s === "lost") return "default";
  if (s === "in_progress" || s === "qualified") return "processing";
  return "default";
}

export function formatAiSalesDate(v) {
  if (v == null || v === "") return "—";
  const s = String(v);
  if (s.length >= 10 && s.includes("-")) return s.slice(0, 10);
  return s;
}
